const fullpageLicense = () => {
  const license = '5683FC71-5BC24572-B0EE9B4C-D8CD6110'
  return license
}

export default fullpageLicense
